import { EventEmitter } from 'tsee'

export const wakeUpEE = new EventEmitter()
